import { render, staticRenderFns } from "./BackWithTitle.vue?vue&type=template&id=16c19cc3"
import script from "./BackWithTitle.vue?vue&type=script&lang=js"
export * from "./BackWithTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports